import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ROUTES from '../../constants/routes';
import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';

const ZendeskWidget = () => {
    const location = useLocation();
    const [loaded, setLoaded] = useState(false);
    const hideWidgetOnUnusedPages = () => {
        const path = window.location.pathname;
        const isAllowedURL =
            path === ROUTES.PAYMENT.path ||
            path === ROUTES.BOUGHT_MATERIALS.path ||
            path === ROUTES.CABINET_SALES.path ||
            path === ROUTES.THANK_YOU_PAGE.path ||
            path === ROUTES.SELLER.path;

        if (!isAllowedURL && window?.zE) {
            window.zE('webWidget', 'hide');
        }
    };

    const getWidgetLang = () => {
        if (world === AVAILABLE_WORLDS.GR) {
            return 'el';
        }

        return world;
    };

    hideWidgetOnUnusedPages();

    useEffect(() => {
        if (window?.zE) {
            window.zE('webWidget', 'show');

            return;
        }

        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.id = 'ze-snippet';
        script.src = 'https://static.zdassets.com/ekr/snippet.js?key=70ce7897-bcec-4a9a-bb14-f55cbb5ae45f';
        script.onload = () => {
            setLoaded(true);
        };
        document.head.appendChild(script);

        return () => {
            if (window?.zE) {
                window.zE('webWidget', 'hide');
            }
        };
    }, [world, location.pathname]);

    if (loaded && window?.zE) {
        window.zE('webWidget', 'setLocale', getWidgetLang());

        if (world !== AVAILABLE_WORLDS.DE) {
            try {
                window.zE('webWidget', 'helpCenter:setSuggestions', { search: ' ' });
            } catch (e) {}
        }
    }

    if (window?.zE) {
        if (window.location.pathname === ROUTES.BOUGHT_MATERIALS.path) {
            const config = { search: '' };

            if (world === AVAILABLE_WORLDS.DE) {
                config.search = 'mein gekauftes interactive anpassen';
            }

            window.zE('webWidget', 'helpCenter:setSuggestions', config);
        }
    }

    return <></>;
};

export default ZendeskWidget;
